 
import { useDataStore } from 'src/modules/pe-basic-module/data/store'
import { GET_ALL_TESTS_ACTION, GET_TEST_ACTION, GET_TEST_RESULTS_USERS_ACTION, GET_TEST_TRY_COUNT_ACTION, GET_TEST_USER_RESULT_ACTION, GET_TEST_USER_RESULTS_ACTION,  REMOVE_TEST_RESULT_ACTION,  UPDATE_TEST_USER_RESULT_ACTION } from './actionTypes'
import asyncControllers from './controllers' 
import { IPETest } from './interfaces'
import { useTestsStore } from './store'


export const actions = (action: string, data: any): Promise<any> =>
{  
    //console.table( {teg:"test actions: ", action} )
    let promise: Promise<any> = new Promise<any>((resolve) => resolve(null) ) 
    switch (action) {
        case GET_TEST_ACTION:
            promise = new Promise((resolve, reject) => { 
                asyncControllers(action, data).then( 
                    (response : any) => { 
                        // console.log( data, response )
                        actions(
                            GET_TEST_TRY_COUNT_ACTION,
                            { user_id: data.user_id, test_id: data.id }
                        ).then(result => {
                            if(!response.data.getTest) {
                                resolve({})
                                return
                            }
                            // console.log( response.getTest.try_count - result ) 
                            const _test = {
                                ...response.data.getTest,
                                try_count: (response.data.getTest?.try_count || 0) - result
                            }
                            useDataStore.setState({
                                PETest: [
                                    ...(
                                        ( useDataStore.PETest || [] )
                                            .filter(( t: IPETest ) => t.id === response.data.getTest?.id )
                                            .map((t: IPETest) => ({ ...t, try_count: t.try_count - result }))
                                    ),
                                    _test
                                ]
                            })
                            resolve( _test )
                        }) 
                    },
                    (error: any) => reject( error )
                )
            })
            return promise
        case GET_ALL_TESTS_ACTION:
            promise = new Promise((resolve, reject) => { 
                asyncControllers(action, data).then( 
                    (response : any) => { 
                        resolve( response.data.getAllTests )
                    },
                    (error: any) => reject( error )
                )
            })
            return promise
        case REMOVE_TEST_RESULT_ACTION:
            promise = new Promise((resolve, reject) => { 
                asyncControllers(action, data).then( 
                    (response : any) => {  
                        //console.log( response.data.removeTestResult )                        
                        resolve( response.data.removeTestResult ) 
                    },
                    (error: any) => reject( error )
                )
            })
            return promise 
        case GET_TEST_TRY_COUNT_ACTION:
            promise = new Promise((resolve, reject) => { 
                asyncControllers(action, data).then( 
                    (response : any) => {  
                        //console.log( response.data.getTestTryCount )                        
                        resolve( response.data.getTestTryCount ) 
                    },
                    (error: any) => reject( error )
                )
            })
            return promise 
        case GET_TEST_USER_RESULTS_ACTION:
            promise = new Promise((resolve, reject) => { 
                asyncControllers(action, data).then( 
                    (response : any) => {  
                        //console.log( response.data.getUserTestResults )
                        
                        actions(GET_TEST_ACTION, {})
                        resolve( response.data.getUserTestResults ) 
                    },
                    (error: any) => reject( error )
                )
            })
            return promise 
        case GET_TEST_RESULTS_USERS_ACTION:
            promise = new Promise((resolve, reject) => { 
                asyncControllers(action, data).then( 
                    (response : any) => {  
                        // console.log( response.data.getTestResultsUser )
                        const users = (response.data.getTestResultsUser || []).map( (r: any) => r.user )
                        useDataStore.getState().addTo("User", users)
                        resolve( response.data.getTestResultsUser ) 
                    },
                    (error: any) => reject( error )
                )
            })
            return promise 
        case GET_TEST_USER_RESULT_ACTION: 
            promise = new Promise((resolve, reject) => { 
                asyncControllers(action, data).then( 
                    (response : any) => {
                        resolve( response.data.getTestResult ) 
                    },
                    (error: any) => reject( error )
                )
            })
            return promise
        case UPDATE_TEST_USER_RESULT_ACTION:
            console.log( data )
            promise = new Promise((resolve, reject) => { 
                asyncControllers(action, data).then( 
                    (response : any) => { 
                        // console.log( response )
                        // const ur = useTestsStore.getState().userResults
                        // useTestsStore.setState({
                        //     userResults: {
                        //         ...ur,
                        //         [data.user_id] : {
                        //             user: data.user,
                        //             ...(ur[data.user_id] || {}),
                        //             [data.test.id] : {
                        //                 item: {
                        //                     id:data.test.id,
                        //                     title: data.test.title
                        //                 },
                        //                 result: data.results
                        //             }
                        //         }

                        //     }
                        // })
                        resolve( response.updateTestResult )
                    },
                    (error: any) => reject( error )
                )
            })
            return promise
        default:
            promise = new Promise((resolve, reject) => { 
                asyncControllers(action, data).then( 
                    (response : any) => { 
                        resolve( response )
                    },
                    (error: any) => reject( error )
                )
            })
            return promise
    }

} 

export const syncAction = (action: string, data: any): any => {
    switch(action) { 
        default:
            return action
    }
    
}